var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F26822;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,150c0,82.8-67.1,150-150,150S0,232.8,0,150S67.1,0,150,0S300,67.1,300,150z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_149931032",
    className: "st1",
    d: "M150,0C67.2,0-0.1,67.2,0,150c0,16.6,2.7,32.5,7.6,47.4h44.9V71.2l97.5,97.5l97.5-97.5v126.2 h44.9c5-14.9,7.6-30.8,7.6-47.4C300.1,67.2,232.8,0,150,0L150,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_149931160",
    className: "st1",
    d: "M127.6,191.1L85,148.5v79.4H52.5l-30.7,0C48.1,271.1,95.7,300,150,300s101.8-28.9,128.2-72.1 h-63.2v-79.4l-42.5,42.5L150,213.5L127.6,191.1L127.6,191.1L127.6,191.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmr);
export default __webpack_public_path__ + "static/media/XMR.fbe085216797625f7105a1b692660939.svg";
export { ForwardRef as ReactComponent };